module.exports = __webpack_public_path__ + "static/img/logo1s.8fb66ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/logo1s.png
// module id = t/MT
// module chunks = 1